module.exports = __webpack_public_path__ + "static/media/slider4.c8642c63.jpg";